import {Color, FinishGroup, Material, ProviderInfo} from '../types'

export const createInternalMaterialId = (
  material: Material,
  finishGroup: FinishGroup,
  color: Color
) => `${material.name} ${finishGroup.name} ${color.name}`.replace(/\W/g, '_').toLowerCase()

export const getMissingProviderInfoData = (providerInfo: ProviderInfo) => {
  const reasons: Record<string, true> = {}

  if (!providerInfo.productionTimeFast) {
    reasons.productionTimeFast = true
  }

  if (!providerInfo.productionTimeSlow) {
    reasons.productionTimeSlow = true
  }

  if (!providerInfo.maximumDimensions) {
    reasons.maximumDimensions = true
  }

  if (!providerInfo.priceId) {
    reasons.priceId = true
  }

  if (!providerInfo.printingMethodId) {
    reasons.printingMethodId = true
  }

  return reasons
}
